export default __webpack_public_path__ + "static/media/code-quality.2193277d.svg";